import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=29987fc1&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=29987fc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29987fc1",
  null
  
)

export default component.exports